export const dateTimeFilterConstants = {
    anyTimeTitle: "Any Time",
    radioInputLabel: "Time (EST)",
};
